<template>
    <div>
        <h1>Hi {{user.firstName}}!</h1>
        <h3>Users from secure api end point:</h3>
        <em v-if="users.loading">Loading users...</em>
        <span v-if="users.error" class="text-danger">ERROR: {{users.error}}</span>
        <ul v-if="users.items">
            <li v-for="user in users.items" :key="user.id">
                {{user.firstName + ' ' + user.lastName}}
            </li>
        </ul>       
    </div>
</template>

<script>
    export default {
        computed: {
            user() {
                return this.$store.getters['Authentication/getUserToken'];
            },
            users() {
                return this.$store.state.Users.all;
            }
        },
        created() {
            this.$store.dispatch('Users/getUsers');
        }
    };
</script>

<style scoped>
</style>